mutation AddWhitelabelingDomain(
  $workspaceId: ID!
  $rootDomain: String!
  $fromEmailAddress: String
) {
  addWhitelabelingDomain(
    workspaceId: $workspaceId
    rootDomain: $rootDomain
    fromEmailAddress: $fromEmailAddress
  ) {
    id
  }
}
